import axios from '@/shared/utils/axios-init';


const initialState = {
  notificationsData: [],
};

const getters = {
  getNotificationsData: state => state.notificationsData,
};

const mutations = {
  setNotificationsData(state, notifications) {
    state.notificationsData = notifications;
  },
  markNotification(state, id) {
    /* eslint-disable */
    state.notificationsData.find(notification => {
      if (notification.id === id) {
        notification.is_unread = 0;
      }
    });
  },
};

const actions = {
  async fetchNotificationsData({ commit }) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const lang = localStorage.getItem('language');
      const data = await axios.post('cabinet/notifications', JSON.stringify({ lang }), { headers: { Authorization: `Bearer ${token}` } });

      commit('setNotificationsData', data.data.notifications);

      return data;
    } catch (error) {
      return error.response;
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Account/modules/notifications.js